// Nota de alarmes suprimidos por anti-flood. A info de que houve supressão
// permanece visível (sem o rótulo de norma "ISA 18.2"). Canônica num só lugar.
export function SuppressedAlarmsNote({
  count,
  className = "",
}: {
  count: number;
  className?: string;
}) {
  if (count <= 0) return null;
  return (
    <p className={`text-[11px] text-text-tertiary ${className}`}>
      + {count} alarme(s) suprimido(s) no mesmo grupo (anti-flood).
    </p>
  );
}
